import React from 'react'
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader'
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar'
import ShopManagementPageHero from '../../components/Shop/Layout/ShopManagementPageHero';
import AllRefundOrders from "../../components/Shop/AllRefundOrders";

const ShopAllRefunds = () => {
  return (
    <div className="shop-management-page">
    <DashboardHeader />
    <div className="shop-management-layout">
        <div className="shop-management-sidebar-slot">
          <DashboardSideBar active={18} />
        </div>
        <main className="shop-management-main-panel">
            <ShopManagementPageHero
            eyebrow="Order Care"
            title="Refunds"
            copy="Review refund requests and completed refund activity in a contained responsive table."
            />
           <AllRefundOrders />
        </main>
      </div>
</div>
  )
}

export default ShopAllRefunds